<!-- <mat-spinner></mat-spinner> -->
<div class="min-h-screen w-full flex flex-col bg-violet-50">
  <div class="fixed inset-0 flex justify-center items-center" *ngIf="enableSpinner">
    <div class="spinner-border border-t-transparent rounded-full animate-spin border-[#E31C79] border-4 h-8 w-8"></div>
  </div>
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer class="mt-auto "></app-footer>
</div>